import { render, staticRenderFns } from "./BrowseProjects.vue?vue&type=template&id=200c153c&"
import script from "./BrowseProjects.vue?vue&type=script&lang=js&"
export * from "./BrowseProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports